import request from '@/utils/request'

const basePath = '/api/file'

export function commonUpload(formData) {
    return request({
        url: `${basePath}/common/upload`,
        method: 'POST',
        data: formData,
    })
}